import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const Accelerate = () => {
  return (
    <Container>
      <Row className="align-items-center">
        {/* Left Side: Text and Button */}
        <Col md={6} className="text-section">
          <h2 className="caliber-title">
            Partner with CLIF AI to boost placements and future-proof your
            universities
          </h2>
          <p className="accelerate-subtitle">
            At <b>CLIF AI,</b> we help universities prepare students for
            real-world careers using <b>AI-powered guidance</b> and{" "}
            <b>real mentorship</b> from industry experts.
            <br />
            Many students feel confused about their career path. They struggle
            with choosing the right job, improving their skills, and building
            confidence.
            <b>CLIF AI solves this problem for your institution.</b>
            <br />
          </p>
          <p></p>
          <a href="/price-discussion" className="btn-primary try-free-btn">
            Book A Free Demo Now
          </a>
        </Col>

        {/* Right Side: Video Placeholder */}
        <Col md={6} className="video-section">
          <div className="video-placeholder hackathon-image">
            <img
              src="../../../images/recruiters/group-7.png"
              alt="Chris Jackson"
              className="expert-img"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Accelerate;
